const COMMIT_KEYS = new Set([
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Home",
  "End",
  "PageUp",
  "PageDown",
]);

export default function Slider({
  id,
  label,
  value,
  color,
  onChange,
  onCommit,
}) {
  return (
    <div
      className="slider"
      style={{ "--slider-value": value, "--slider-color": color }}
    >
      <label className="slider__label" htmlFor={id}>
        {label}
      </label>
      <div className="slider__track">
        <div className="slider__fill" />
        <input
          className="slider__input"
          id={id}
          type="range"
          min="0"
          max="100"
          value={value}
          onChange={(event) => onChange(Number(event.target.value))}
          onPointerUp={onCommit}
          onKeyUp={(event) => {
            if (!COMMIT_KEYS.has(event.key)) return;
            onCommit();
          }}
        />
      </div>
    </div>
  );
}
